import ContractSignatureLaunchModal from './component';
import { ContractSignatureLaunchModalProps } from './types';

export default ContractSignatureLaunchModal;
export type { ContractSignatureLaunchModalProps };
